module.exports = __webpack_public_path__ + "media/images/flags/64/Cambodia-2dab6eabfb6dbad19b554b88bdb8a7ce.png";